const generateColor = () => {
    return "hsl(" + 360 * Math.random() + ',' +
        (25 + 70 * Math.random()) + '%,' +
        (70 + 10 * Math.random()) + '%)'
}

export {
    generateColor
}